<template>
  <section  class="content-tlist" style="margin: 30px 0;">
    <h2>Profile Settings</h2>
    <template v-if="featureFundsStatus != null">
      <table class="content-table">
        <template v-if="hideVerificationPermissionsReview">
          <tr class="space">
            <th width="200">Verifications</th>
            <th>Administrative</th>
            <th>Remote Deposit Capture</th>
            <th v-if="!isPersonal">Double Verification</th>
          </tr>
          <tr class="content-filters">
            <td><span>Verifications</span> Enable</td>
            <td><span>Administrative</span>
              <mnb-switch v-model="form.administrative" :validator="$v.form.administrative" :disabled="!updateSettings" />
            </td>
            <td><span>Remote Deposit Capture</span>
              <mnb-switch v-model="form.remoteDepositCapture" :validator="$v.form.remoteDepositCapture" :disabled="!updateSettings" />
            </td>
            <td v-if="!isPersonal"><span>Double Verification</span>
              <mnb-switch v-model="form.double_verification" :validator="$v.form.double_verification" disabled />
            </td>
            <td colspan="7"></td>
          </tr>
          <tr class="space">
            <th width="200">Permissions</th>
            <th>Create Sub-Users</th>
            <th v-if="isMasterBusiness">Create Sub-Profiles</th>
          </tr>
          <tr class="content-filters">
            <td><span>Permissions</span> Enable</td>
            <td><span>Create Sub-Users</span>
              <mnb-switch v-model="form.create_subusers" :validator="$v.form.create_subusers" :disabled="!updateSettings" />
            </td>
            <td v-if="isMasterBusiness"><span>Create Sub-Profiles</span>
              <mnb-switch v-model="form.create_subprofiles" :validator="$v.form.create_subprofiles" disabled />
            </td>
            <td colspan="7"></td>
          </tr>
        </template>
        <tr class="space">
          <th width="200">Options</th>
          <th>Send Confirmation Emails</th>
          <th v-if="hideVerificationPermissionsReview">Profile Review Days</th>
          <th>Profile Language</th>
        </tr>
        <tr class="content-filters">
          <td></td>
          <td><span>Send Confirmation Emails</span>
            <mnb-switch v-model="form.welcome_email" :validator="$v.form.welcome_email" :disabled="!updateSettings" />
          </td>
          <td v-if="hideVerificationPermissionsReview"><span>Profile Review Days</span>
            <mnb-select v-if="updateSettings" v-model="form.review_days" :validator="$v.form.review_days" class="select"  :options="reviewOptions" />
            <template v-else>{{ form.review_days }}</template>
          </td>
          <td><span>Profile Language</span>
            <mnb-select v-if="updateSettings" v-model="form.language" :validator="$v.form.language" class="select"  :options="languageOptions" />
            <template v-else>{{ form.language }}</template>
          </td>
          <td colspan="5"></td>
        </tr>
      </table>
    </template>

    <div v-if="noDateUpdate" class="footer space">
      <span>
        <b>&nbsp;</b><br>
        <template v-if="updateSettings">&nbsp;</template>
        <template v-else>&nbsp;<br>&nbsp;</template>
      </span>
      <div>
        <template v-if="$hasPerm('update-profile')">
          <button v-if="updateSettings" class="main" @click="save()">Save</button>
          <button v-else class="second" @click="update()">Update</button>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import MnbInput from '../../components/ui/forms/Input'
import MnbSelect from '../../components/ui/forms/Select'
import MnbSwitch from '../../components/ui/forms/Switch'

import { required } from 'vuelidate/lib/validators'

const initialForm = {
  domWires: null,
  intlWires: null,
  ach: null,
  checks: null,
  exchange: false,
  acc_to_acc: null,
  assets: null,
  trade_desk: null,
  multiCurrency: null,
  debitCards: null,
  domWires_limit: null,
  intlWires_limit: null,
  ach_limit: null,
  checks_limit: null,
  exchange_limit: null,
  acc_to_acc_limit: null,
  assets_limit: null,
  trade_desk_limit: null,
  multi_currency_limit: null,
  debit_cards_limit: null,

  administrative: false,
  remoteDepositCapture: false,
  double_verification: false,

  create_subusers: false,
  create_subprofiles: false,

  welcome_email: false,
  review_days: null,
  language: null
}

export default {
  props: {
    registration: {
      type: Object,
      required: true
    },
    noDateUpdate: {
      type: Boolean,
      default: false
    },
    hideVerificationPermissionsReview: {
      type: Boolean,
      default: false
    },
  },

  components: {
    MnbInput,
    MnbSelect,
    MnbSwitch
  },

  data () {
    return {
      form: { ...initialForm },

      updateSettings: false,

      reviewOptions: [
        {
          id: 30,
          text: 30
        },
        {
          id: 60,
          text: 60
        },
        {
          id: 90,
          text: 90
        },
        {
          id: 180,
          text: 180
        },
        {
          id: 365,
          text: 365
        }
      ],

      languageOptions: [
        {
          id: 'English',
          text: 'English'
        }
      ],

      featureFundsStatus: null,
      featureAssetsStatus: null,
      featureTradeStatus: null,
    }
  },

  computed: {
    isPersonal () {
      return this.registration?.type === 'Personal'
    },

    isMasterBusiness () {
      return this.registration?.type === 'Master Business'
    },

    profileSettings () {
      return this.registration.profileSettings || null
    },

    provider () {
      return this.providers.find(provider => provider.id === this.registration.serviceProviders.provider.id)
    },

    providers () {
      return this.$store.state.providersList.data || []
    },
  },

  async created () {
    if (this.profileSettings) {
      this.form = this.profileSettings
    }
    await this.$store.dispatch('providersList/load', { order: ['createdAt:DESC'] })
    await this.getFeatureStatus();
  },

  methods: {
    async save () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return
      const loader = this.$loading.show()
      try {
        await this.$store.dispatch('reg_profile_settings/update', {
          id: this.registration.profileSettings.id,
          payload: {
            ...this.form,
          }
        })
        await this.setLastUpdatedAt()
        this.updateSettings = false
        this.$toast.success('Profile Settings successfully created.')
      } catch (e) {
        this.$toast.error(e.message)
      } finally {
        loader.hide()
      }
    },

    setLastUpdatedAt () {
      return this.$store.dispatch('profilenotes/create', {
        createdBy: window.appData.currentUser.id,
        registrationId: this.registration.id,
        notes: 'Profile settings updated',
        createdAt: 'CURRENT_TIMESTAMP'
      })
    },

    async update () {
      this.updateSettings = true
    },

    async getFeatureStatus () {
      this.featureAssetsStatus = window.systemFeatures['Digital Assets']
      this.featureFundsStatus = window.systemFeatures['Multi-Currency']
      this.featureTradeStatus = window.systemFeatures['Trade Desk']
    },
  },

  validations () {
    const rules = {
      form: {
        administrative: { required },
        remoteDepositCapture: { required },
        create_subusers: { required },
        welcome_email: { required },
        review_days: { required },
        language: { required }
      }
    }

    if (!this.isPersonal) {
      rules.form.double_verification = { required }
      rules.form.create_subprofiles = { required }
    }

    return rules
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px; 
  color: #0075be; 
  padding: 10px;
}

.checkbox-large {
  width: 17px;
  height: 17px;
}

.money-input {
  display: flex;
  span {
    display: inline-block;
    width: 15px;
    line-height: 29px;
  }
  .input {
    width: 100px;
  }
}
.select {
  width: 115px;
}

.space {
  td, th {
    padding-top: 20px;
  }
}

.footer {
  display: flex;
  padding: 0 34px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.switch {
  display: inline-block;
  margin-right: 40px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 999px;
  line-height: 20px;
  padding: 3px 3px 3px 10px;
  box-sizing: border-box;
  font-size: 13px;
  color: #666;
  float: left;
  min-width: 90px;
  text-align: right;
}
.switch i {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  margin-left: 3px;
}
.switch i.green {
  background-color: #67C23A;
}
.switch i.grey {
  background-color: #666;
}

</style>
